/**
 * @file 评论卡片组件
 * @author yanyiting@baidu.com
 * */

import {Component} from 'san';
import './index.scss';
import {getPublishTime} from '@utils/filter';

export default class CommentCard extends Component {
    static template = `
        <div class="comment-card-wrap" style="{{commentNum ? '' : 'padding-bottom: 24px;'}}">
            <div class="title">评论</div>
            <div class="input-area">
                <div class="avatar"
                    style="background: url({{commentAvatar ? commentAvatar
                    : 'http://himg.bdimg.com/sys/portrait/item/22217370616365f5b6.jpg'}}) center / cover no-repeat;">
                </div>
                <div class="input" on-click="inputClick">{{commentNum ? '说点什么…' : '暂时还没有评论，快来抢占沙发！'}}</div>
            </div>
            <div class="list-area" s-if="commentNum">
                <div s-for="item, index in list" class="comment-item">
                    <div class="avatar"
                        style="background: url({{item.author.avatar}}) center / cover no-repeat;"></div>
                    <div class="comment-right">
                        <div class="comment-head">
                            <div class="nickname">{{item.author.nickname}}</div>
                            <div class="zan" on-click="likeClick">
                                <span></span>
                                <span s-if="item.likeNum">{{item.likeNum}}</span>
                            </div>
                        </div>
                        <div class="comment-main">
                            <div class="comment-content">{{item.content}}</div>
                            <div class="comment-time">{{item.pubTime | getPublishTime}}</div>
                            <div class="comment-reply" s-if="item.repliedList && item.repliedList.length">
                                <div class="reply-content">
                                    <span>{{item.repliedList[0].author.nickname}}&nbsp;:</span>
                                    <span>{{item.repliedList[0].content}}</span>
                                </div>
                                <div class="see-all-reply-comment"
                                    s-if="item.repliedCount > 1"
                                    on-click="seeReplyClick">
                                    <span>展开{{item.repliedCount}}条回复</span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="see-all-comment"
                s-if="commentNum > 2"
                on-click="seeCommentClick">{{viewMoreText}}</div>
        </div>
    `;

    initData() {
        return {
            viewMoreText: '打开 App 查看、参与讨论'
        };
    }

    static filters = {
        getPublishTime
    };

    // 评论框点击
    inputClick() {
        this.fire('inputclick');
    }

    // 点赞
    likeClick() {
        this.fire('likeclick');
    }

    // 查看所有回复
    seeReplyClick() {
        this.fire('seereplyclick');
    }

    // 查看所有评论
    seeCommentClick() {
        this.fire('seecommentclick');
    }
}
